/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserAttribute from './user-attribute';
import UserAttributeDetail from './user-attribute-detail';
import UserAttributeUpdate from './user-attribute-update';
import UserAttributeDeleteDialog from './user-attribute-delete-dialog';

const UserAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserAttribute />} />
    <Route path="new" element={<UserAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<UserAttributeDetail />} />
      <Route path="edit" element={<UserAttributeUpdate />} />
      <Route path="delete" element={<UserAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserAttributeRoutes;
